import { MoipServices } from "./services/moipServices";
import { MercadoPagoServices } from "./services/mercadoPagoServices";
import { EvHubPaymentServices } from "./services/evHubServices";

class CardValidatorFactory {
    getValidator(gatewayName) {
        if(gatewayName)
            return this[`_${gatewayName.toLowerCase()}`]()
        return this._evolvehub()
    }

    _evolvehub() {
        return new EvHubPaymentServices();
    }

    _mercadopago() {
        return new MercadoPagoServices();
    }

    _wirecard() {
        return new MoipServices();
    }
}

export default new CardValidatorFactory();